export interface Product {
  id: string;
  nameKey: string;
  descKey: string;
  size: '130g' | '440g' | '950g';
  imageUrl: string;
  isVegan?: boolean;
  ingredients: string;
}

export const products130g: Product[] = [
  {
    id: 'berries',
    nameKey: 'product.berries.name',
    descKey: 'product.berries.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/fa923890-f6dd-44e5-89ac-448c677ba00b_compressed_Berries130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, mezcla de berries (fresa, arándano, frambuesa).',
  },
  {
    id: 'chocolate',
    nameKey: 'product.chocolate.name',
    descKey: 'product.chocolate.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/b6f9d96d-ed4e-400d-90c4-ccbd4720ba13_compressed_Chocolate130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, cacao natural.',
  },
  {
    id: 'cas',
    nameKey: 'product.cas.name',
    descKey: 'product.cas.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/16c3c53c-6de2-418a-8639-07ab50d7631f_compressed_Cas130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, cas natural.',
  },
  {
    id: 'strawberry',
    nameKey: 'product.strawberry.name',
    descKey: 'product.strawberry.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/45e713ad-8aa6-432b-8877-3a6c08e7d16f_compressed_Fresa130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, fresa natural.',
  },
  {
    id: 'mango-maracuya',
    nameKey: 'product.mango_maracuya.name',
    descKey: 'product.mango_maracuya.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/35a81b47-1ac6-4c5d-8477-390f4f955b46_compressed_MM130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, mango natural, maracuyá natural.',
  },
  {
    id: 'pina-colada',
    nameKey: 'product.pina_colada.name',
    descKey: 'product.pina_colada.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/597a15fb-9a24-4f37-a999-3fac50aa7250_compressed_PiaCoco130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, piña natural, coco natural.',
  },
  {
    id: 'sandia',
    nameKey: 'product.sandia.name',
    descKey: 'product.sandia.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/595859bf-aa9d-48fe-985d-f3f92f9c84b7_compressed_Sandia130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, sandía natural.',
  },
  {
    id: 'taro',
    nameKey: 'product.taro.name',
    descKey: 'product.taro.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/8b70f735-5095-4abf-8f92-f5893b25e187_compressed_Taro130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, taro natural.',
  },
  {
    id: 'vainilla',
    nameKey: 'product.vainilla.name',
    descKey: 'product.vainilla.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/4c6a782d-8d36-4fd1-b85c-c1aad1b6581b_compressed_Vainilla130g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, vainilla natural.',
  },
  {
    id: 'coco',
    nameKey: 'product.coco.name',
    descKey: 'product.coco.desc',
    size: '130g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/309a6377-a5b8-497b-bde6-19347e8f3575_compressed_BaseCoco130g.webp',
    isVegan: true,
    ingredients: 'Ingredientes: Extracto de coco, cultivos, estabilizante, producto vegetal fermentado a base de coco.',
  },
];

export const products440g: Product[] = [
  {
    id: 'natural-440',
    nameKey: 'product.natural.name',
    descKey: 'product.natural.desc',
    size: '440g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/02453041-4b89-4fa0-acd7-1bd33309430b_compressed_Natural440g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos.',
  },
  {
    id: 'vainilla-440',
    nameKey: 'product.vainilla.name',
    descKey: 'product.vainilla.desc',
    size: '440g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/01baef4b-bbde-4b1a-b7d8-ca3d52fae312_compressed_Vainilla440g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, vainilla natural.',
  },
  {
    id: 'taro-440',
    nameKey: 'product.taro.name',
    descKey: 'product.taro.desc',
    size: '440g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/fe3fd512-0433-411f-8b38-4c32d19a02cc_compressed_Taro440g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, taro natural.',
  },
  {
    id: 'sandia-440',
    nameKey: 'product.sandia.name',
    descKey: 'product.sandia.desc',
    size: '440g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/12356105-5211-413e-ade6-3c4275969eca_compressed_Sandia440g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, sandía natural.',
  },
  {
    id: 'coco-440',
    nameKey: 'product.coco.name',
    descKey: 'product.coco.desc',
    size: '440g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/4bb8ff6c-ed41-4a0b-853a-c15492cb6b4f_compressed_BaseCoco440g.webp',
    isVegan: true,
    ingredients: 'Ingredientes: Extracto de coco, cultivos, estabilizante, producto vegetal fermentado a base de coco.',
  },
];

export const products950g: Product[] = [
  {
    id: 'natural-950',
    nameKey: 'product.natural.name',
    descKey: 'product.natural.desc',
    size: '950g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/8d86949d-bb2f-4094-9887-4d90e9d0a746_compressed_Natural950g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos.',
  },
  {
    id: 'vainilla-950',
    nameKey: 'product.vainilla.name',
    descKey: 'product.vainilla.desc',
    size: '950g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/39b514d3-1166-4689-8404-d93b79d64b5a_compressed_Vainilla950g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, vainilla natural.',
  },
  {
    id: 'taro-950',
    nameKey: 'product.taro.name',
    descKey: 'product.taro.desc',
    size: '950g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/1d447eda-1cc1-4775-8fef-66f3284c365f_compressed_Taro950g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, taro natural.',
  },
  {
    id: 'sandia-950',
    nameKey: 'product.sandia.name',
    descKey: 'product.sandia.desc',
    size: '950g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/72e395e1-d926-4950-8a95-2342d37fb291_compressed_Sandia950g.webp',
    ingredients: 'Ingredientes: Leche deslactosada, cultivos vivos, sandía natural.',
  },
  {
    id: 'coco-950',
    nameKey: 'product.coco.name',
    descKey: 'product.coco.desc',
    size: '950g',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/5b74fef7-5fbb-4507-ab82-f78009e6c2db_compressed_BaseCoco950g.webp',
    isVegan: true,
    ingredients: 'Ingredientes: Extracto de coco, cultivos, estabilizante, producto vegetal fermentado a base de coco.',
  },
];

export const allProducts: Product[] = [...products130g, ...products440g, ...products950g];